module.exports = __webpack_public_path__ + "static/media/visa.000818c6.svg";